export default __webpack_public_path__ + "static/media/brand-7.96eaf4c3.jpg";